import React from 'react';
const DEEPWATCH_IMAGES = {
  card: 'https://cdn.magicpatterns.com/uploads/9ogtmvGRacMFKm7wgJKKja/DW_Card_thumb.png',
  caseStudy: 'https://cdn.magicpatterns.com/uploads/rgCKZoZP3AanP1wAsNZMDE/DW_Case_Study_hero.png'
} as const;
type DeepwatchHeroProps = {
  variant?: 'card' | 'case-study';
};

/** Exact Deepwatch product art supplied for the portfolio. */
export function DeepwatchHero({
  variant = 'card'
}: DeepwatchHeroProps) {
  const isCaseStudy = variant === 'case-study';
  const src = isCaseStudy ? DEEPWATCH_IMAGES.caseStudy : DEEPWATCH_IMAGES.card;
  const alt = isCaseStudy ? 'Deepwatch Security Center dashboard views' : 'Deepwatch Security Center dashboard interface';
  return <img src={src} alt={alt} className="h-full w-full object-cover object-center" loading={isCaseStudy ? 'eager' : 'lazy'} decoding="async" data-id="element-273" data-mp="21dvuspteg49m" />;
}